var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.$style.wrapper,attrs:{"data-test-id":"MobileOptionButton"},on:{"click":_vm.open}},[_c('el-image',{class:_vm.$style.icon,attrs:{"src":_vm.option}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }